export default {
  RECEIPTS: "receipts", //Po računu popravila ali naprave
  EVALUATION: "evaluation", //Po ocenitvi
  DONT_KNOW: "dontKnow", //Ne vem
}